// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/css/tipsMessage.css
// module id = p6Qk
// module chunks = 88